import * as request from '@/utils/request'

export default {
  /**
   * @description 获取菜单树结构
   * @returns promise
   */
  getMenuTree() {
    return request.get('/menu/tree')
  },
  /**
   * @description 新增菜单
   * @param {*} data { parent_id, type, display_name, icon, url, permission_name, sort, status }
   * @returns promise
   */
  createMenu(data) {
    return request.post('/menu/create', data)
  },
  /**
   * @description 更新菜单
   * @param {*} data 包含 id 及要更新的字段
   * @returns promise
   */
  updateMenu(data) {
    return request.post('/menu/update', data)
  },
  /**
   * @description 删除菜单
   * @param {*} id 菜单ID
   * @returns promise
   */
  deleteMenu(id) {
    return request.post('/menu/main_menu_delete', { id })
  }
}
